import { Box, Stack } from '@mui/material'
import { IDiagnosticNotification } from 'utils/interfaces'
import DiagnosticNotification from './DiagnosticNotification'

interface Props {
  notifications: IDiagnosticNotification[]
  onAction: (notificationId: string, buttonId: string) => void
  /** Ид уведомления, по которому идёт обработка. */
  loadingNotifId?: string
  /** Ид нажатой кнопки, пока идёт обработка. */
  loadingButtonId?: string
}

const DiagnosticOverlay = ({ notifications, onAction, loadingNotifId, loadingButtonId }: Props) => {
  if (notifications.length === 0) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 80, // Offset for header
        right: 20,
        zIndex: 2000,
        maxHeight: '50vh',
        overflowY: 'auto',
        pr: 1, // Space for scrollbar
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#ccc',
          borderRadius: '3px',
        },
      }}
    >
      <Stack direction="column-reverse">
        {notifications.map(notification => (
          <DiagnosticNotification
            key={notification.notification_id}
            notification={notification}
            onAction={buttonId => onAction(notification.notification_id, buttonId)}
            loadingButtonId={
              notification.notification_id === loadingNotifId ? loadingButtonId : undefined
            }
          />
        ))}
      </Stack>
    </Box>
  )
}

export default DiagnosticOverlay
